module.exports = __webpack_public_path__ + "static/media/IVBDS.7a7b74d9.pdf";